export default __webpack_public_path__ + "static/media/led1_down_overay.01e0c01a.svg";